import { useOnboarding } from "@/components/owner/OnboardingProvider";
import { useOwnerAuth } from "@/components/owner/OwnerAuthProvider";
import { readOwnerOnboardingStep } from "@/lib/onboardingBusiness";
import { resolveOwnerOnboardingResumePath } from "@/lib/onboardingResume";
import { router } from "expo-router";
import React, { useEffect } from "react";
import { ActivityIndicator, Text, View } from "react-native";

export default function OnboardingHome() {
  const { user } = useOwnerAuth();
  const { businessId } = useOnboarding();
  const ownerId = user?.uid;

  useEffect(() => {
    if (!ownerId || !businessId) return;

    let cancelled = false;

    // The gate only mounts this index for an authorized draft. Running here
    // ensures the onboarding Stack exists before replacing with a child route.
    void (async () => {
      try {
        const ownerOnboardingStep = await readOwnerOnboardingStep(ownerId);
        if (cancelled) return;

        router.replace({
          pathname: resolveOwnerOnboardingResumePath({
            status: "draft",
            ownerOnboardingStep,
          }),
          params: { businessId },
        } as any);
      } catch {
        if (cancelled) return;
        console.warn("Owner onboarding resume failed.");
        router.replace("/(owner)/dashboard" as any);
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [ownerId, businessId]);

  return (
    <View style={{ flex: 1, justifyContent: "center", alignItems: "center" }}>
      <ActivityIndicator />
      <Text style={{ marginTop: 10, fontWeight: "900" }}>
        Checking onboarding...
      </Text>
    </View>
  );
}
